const path = '/img/products/RTC';
const docConfig = { name: '产品文档', link: '/document' };
export const BANNER_DATA = {
  title: '实时音视频',
  backgroundImg: `${path}/banner.webp`,
  description:
    '基于亿级DAU业务的实践沉淀和技术积累，帮助开发者快速构建高质量、低延时的实时音视频互动解决方案，实现多人音视频通话和互动直播等多样化场景',
  buttonText: '申请试用',
  buttonLink: '',
  mobileExtraButton: { ...docConfig },
  backgroundImgMobile: `${path}/bannerMobile.webp`,
  docText: '产品文档',
  links: [
    { ...docConfig },
    { name: '管理控制台', link: `${process.env.NEXT_PUBLIC_RTC_BASE_URL}/` },
  ],
};

export const FEATURES = [
  {
    title: '实时音视频通话',
    content:
      '提供灵活易用的全平台SDK，可快速实现两人或多人音视频通话，支持 500 路以上的音视频上行',
    picUrl: `${path}/icon5.webp`,
  },
  {
    title: '旁路推流',
    content:
      '支持将实时音视频流进行云端混流和转码，并推流到指定直播CDN，可选择预设模板或自定义布局等多种布局方式',
    picUrl: `${path}/icon6.webp`,
  },
  {
    title: '录制和截图',
    content:
      '支持对实时音视频通话全程进行云端录制和截图功能，可自定义录制和截图任务参数，支持将文件存储到第三方云存储空间',
    picUrl: `${path}/icon7.webp`,
  },
  {
    title: '质量监控和分析平台',
    content:
      '基于KRTC全链路通讯质量监控，支持多维度的数据统计和分析，帮助开发者快速定位和分析故障问题',
    picUrl: `${path}/icon8.webp`,
  },
];

export const ADVANTAGES = [
  {
    title: '极致音视频通话体验',
    content:
      '支持4K高清画质和48KHz 全频带音频采样，支持智能音频3A算法，还原面对面通话效果',
    picUrl: `${path}/icon1.webp`,
  },
  {
    title: '全球节点覆盖',
    content:
      '通过智能调度算法和策略，对全球通讯节点进行实时质量监控和链路选择，满足 200+ 国家和地区的实时互动通话需求',
    picUrl: `${path}/icon2.webp`,
  },
  {
    title: '弱网通话质量保证',
    content:
      '基于KRTC自研音视频编解码算法和KTP传输协议，可以保证在80%网络丢包率和1000ms抖动等多种复合网损情况下，音视频通话清晰流畅',
    picUrl: `${path}/icon3.webp`,
  },
  {
    title: '多维质量监控和智能诊断',
    content: '提供端到端链路质量监控和实时质量分析，快速发现、定位、追踪问题',
    picUrl: `${path}/icon4.webp`,
  },
];

export const SCENARIO = [
  {
    title: '在线教育',
    content:
      '保障高质量、低延时的师生互动，支持小班课、互动大班课等多样化的授课场景，搭建在线教育的解决方案',
    picUrl: `${path}/scenario1.webp`,
    picHoverUrl: `${path}/scenario1-hover.webp`,
    mobileUrl: `${path}/mobile-scenario1.webp`,
    mobileHoverUrl: `${path}/mobile-scenario1-hover.webp`,
  },
  {
    title: '社交互娱',
    content:
      '基于音视频通话、美颜、互动直播等能力，覆盖语聊、秀场直播、连麦PK、在线KTV等丰富场景，开辟社交新玩法',
    picUrl: `${path}/scenario2.webp`,
    picHoverUrl: `${path}/scenario2-hover.webp`,
    mobileUrl: `${path}/mobile-scenario2.webp`,
    mobileHoverUrl: `${path}/mobile-scenario2-hover.webp`,
  },
  {
    title: '办公协同',
    content:
      '支持全球低延迟音视频通话，可满足超过2000人的大型会议场景，提供屏幕共享、云端录制等功能，提升企业办公协同效率',
    picUrl: `${path}/scenario3.webp`,
    picHoverUrl: `${path}/scenario3-hover.webp`,
    mobileUrl: `${path}/mobile-scenario3.webp`,
    mobileHoverUrl: `${path}/mobile-scenario3-hover.webp`,
  },
  {
    title: '云渲染',
    content:
      '毫秒级传输延迟，对标本地渲染体验，满足云游戏、虚拟主播、AI特效等多种场景需求',
    picUrl: `${path}/scenario4.webp`,
    picHoverUrl: `${path}/scenario4-hover.webp`,
    mobileUrl: `${path}/mobile-scenario4.webp`,
    mobileHoverUrl: `${path}/mobile-scenario4-hover.webp`,
  },
];

export const ARCHITECTURE = {
  title: '产品架构',
  picUrl: `${path}/architecture.webp`,
};

export const BRAND = {
  title: '客户案例',
  items: ['快手', 'AcFun', '回森', '快手电丸', '撕歌', '荔枝微课'],
};
